import { Injectable } from '@angular/core';

@Injectable()
export class PageConfig {
  static readonly paths = {
    landingPage: '',
    ocm: {
      root: 'ocm',
      app: ':app',
      new: ':app/new',
      edit: ':app/:id',
      product: 'product/:id',
      billing: 'billing',
      review: 'review',
      renew: 'renew',
      confirmation: 'confirmation',
	    licenses: 'manage-licenses',
      admins: 'manage-admins',
      adminCallback: 'admin-callback',
      abandonCallback: 'abandon-callback',
    },
    invalidPermissions: 'invalid-permissions',
    login: 'login',
    callback: 'oauth/callback'
  };
}
